import { memdbRequest } from "./index.js";
export function getSchool(id, schema, token = "") {
    return memdbRequest.get(`/school/${id}`, {
        params: { schema },
        ...(token && { headers: { token } }),
    });
}
export function getSchools(params, schema, token = "") {
    return memdbRequest.get("/school/name", {
        params: { ...params, schema },
        ...(token && { headers: { token } }),
    });
}
export function updateSchoolBreak({ id, ...data }) {
    return memdbRequest.post(`/school/${id}/break`, {
        body: data,
    });
}
//# sourceMappingURL=school.js.map